export default {
  answerThreshold: 'آستانه پاسخ',
  dependencyCriteria: 'معیار وابستگی',
  dependedQuestion: 'سوال وابسته',
  answerRequired: 'پاسخ الزامی است',
  minimumOptionLengthIs_: 'حداقل تعداد گزینه ها ۲ می باشد',
  option: 'گزینه',
  options: 'گزینه ها',
  number: 'شماره',
  welcomeTitle: 'عنوان خوش آمدگویی',
  thankYouTitle: 'عنوان تشکر',
  welcomePage: 'صفحه خوش آمد گویی',
  thankYouPage: 'صفحه تشکر',
  fillAtLeastOneOf_InputsRequired:
    'وارد کردن حداقل یکی از ورودی های {page} الزامی است',
  Text: 'متن',
  questions: 'سوالات',
  noQuestionAdded: 'سوالی اضافه نشده است',
  questionTypes: {
    text: 'سوال متنی',
    option: 'سوال چند گزینه ای',
    dropdown: 'لیست کشویی',
    range: 'طیف',
    ranking: 'اولویت دهی',
    file: 'آپلود فایل',
    statement: 'متن بدون پاسخ'
  },
  textViewNames: {
    default: 'پاسخ کوتاه',
    textarea: 'پاسخ بلند',
    url: 'لینک',
    number: 'عدد',
    email: 'ایمیل',
    mobile: 'موبایل'
  },
  optionViewNames: {
    default: 'متنی',
    image: 'عکس دار'
  },
  dropdownViewNames: {
    default: 'پیشفرض'
  },
  rangeViewNames: {
    default: 'طیف',
    score: 'امتیاز دهی'
  },
  rankingViewNames: {
    default: 'پیشفرض'
  },
  fileViewNames: {
    default: 'پیشفرض'
  },
  statementViewNames: {
    default: 'پیشفرض'
  },
  questionSettings: 'تنظیمات سوال',
  payAttentionOnQuestionDetail: 'در وارد کردن اطلاعات سوال دقت کنید',
  availableStartTime: 'تاریخ شروع',
  availableExpireTime: 'تاریخ پایان',
  defaultWelcomeTitle: 'خوش آمدید',
  defaultThankYouTitle: 'با تشکر',
  questionCategoryId: 'شناسه دسته پرسش',
  cantLinkQuestionsWithThisCount: 'با این تعداد سوال، امکان ایجاد لینک بین سوالات وجود ندارد',
  oneOrMoreQuestionsHaveNoTitle: 'یک یا چند سوال عنوان ندارند',
  dependentQuestionSettings: 'تنظیمات وابستگی سوال',
  addDependency: 'افزودن وابستگی',
  dependency: 'وابستگی',
  goToQuestion: 'برو به سوال',
  conditions: 'شروط',
  answerOfQuestion: 'جواب سوال'
}
